import { Card, CardContent, Typography, Grid, Box, Chip, Divider } from "@mui/material";
import moment from "moment";
import { cordsType } from "../../pages/exams/Template/Masters/ListWrapper";
import { ObjectValues } from "../../pages/login";
import CardHeader, { singleLineEllipsis } from "./layouts/CardHeader";
import CountChips from "./layouts/CountChips";
import InfoBox from "./layouts/InfoBox";
import CardFooter from "./layouts/CardFooter";
import { displayRow } from "../../GlobalStyles";

export interface ExamProps {
  data: any;
  onclick?: () => void;
  cardsSelected?: cordsType;
  setCardsSelected?: (val: ObjectValues) => void;
  tempSelected?: ObjectValues | null;
  // child:any
}

function ExamCard({
  data,
  onclick,
  setCardsSelected,
  cardsSelected,
  tempSelected,
  // child
}: ExamProps) {
  const tempS = data.id === tempSelected?.data.id;
  const gridView=!true
  return (
    <Card
      sx={{
        borderRadius: 3,
        boxShadow: tempS ? 4 : "none",
        transform: tempS ? "scale(1.01)" : "none",
        border: tempS ? "2px dashed #519C66" : "2px dashed #ccc",
        cursor: "pointer",
        transition: "all 0.2s ease-in-out",
        "&:hover": {
          boxShadow: 4,
          transform: "scale(1.01)",
          border: "2px dashed #519C66",
        },
        pointerEvents: tempS ? "none" : "auto",
      }}
      onClick={onclick}
    >
      <CardContent sx={gridView?{...displayRow}:{}}>
        {/* Header */}
        <CardHeader
          name={data.name}
            onClick={onclick}
            selected={false}
          description={data.description}
          id={data.id}
          status={data.status}
          is_active={data.is_active}
        />

        {/* Description */}
        <Box display="flex" gap={1} justifyContent={"flex-end"} mb={2}>
          <Chip
            label={`Language : ${data.primary_language}`}
            size="small"
            sx={{
              bgcolor: "#fef3c7",
              color: "#92400e",
              ...singleLineEllipsis,
            }}
          />
        </Box>
        {/* Stats Grid 1 */}
        <Grid container spacing={2} mb={2}>
          <Grid item xs={6} sm={3}>
            <CountChips
              selected={tempS ? cardsSelected?.goal : false}
              label="Goals"
              value={data.total_goals}
              color="#f3e8ff"
              text="#16a34a"
            />
          </Grid>
          <Grid item xs={6} sm={3}>
            <CountChips
              selected={ false}
              label="Sections"
              value={data.total_sections}
              color="#f3e8ff"
              text="#7c3aed"
            />
          </Grid>
          <Grid item xs={6} sm={3}>
            <CountChips
              selected={false}
              label="Units"
              value={data.total_units}
              color="#e0f2fe"
              text="#0284c7"
            />
          </Grid>
          <Grid item xs={6} sm={3}>
            <CountChips
              selected={ false}
              label="Topics"
              value={data.total_topics}
              color="#dcfce7"
              text="#16a34a"
            />
          </Grid>
        </Grid>

        {/* Stats Grid 2 */}
        <Grid container spacing={2} mb={2}>
          <Grid item xs={6} sm={4}>
            <CountChips
              label="Subtopics"
              
              selected={ false}
              value={data.total_subtopics}
              color="#eef2ff"
              text="#4f46e5"
            />
          </Grid>
          <Grid item xs={6} sm={4}>
            <CountChips
              label="Clusters"
             
              selected={ false}
              value={data.total_clusters}
              color="#fee2e2"
              text="#dc2626"
            />
          </Grid>
          <Grid item xs={6} sm={4}>
            <CountChips
              label="Questions"
              selected={ false}
              value={data.total_questions}
              color="#fef3c7"
              text="#d97706"
            />
          </Grid>
        </Grid>

        <Divider sx={{ my: 2 }} />
        <CardFooter
          internal_remark={data.internal_remark}
          created_at={data.created_at}
          created_by_id={data.created_by_id}
          modified_at={data.modified_at}
          modified_by_id={data.modified_by_id}
        />
      </CardContent>
    </Card>
  );
}
// Footer Info (for reuse)
function FooterInfo({ label, value }: { label: string; value: string }) {
  return (
    <Typography
      variant="caption"
      color="text.secondary"
      display="block"
      sx={{
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      }}
    >
      <strong>{label}:</strong> {value}
    </Typography>
  );
}

export default ExamCard;